import { useDispatchRule } from "@/hooks/useDispatchRule"
import ConfirmModal from "@/UI/Modals/ConfirmModal"
import { faTrash } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { message } from "antd"
import { useTranslation } from "react-i18next"
import React from "react"

interface DeleteRuleModalProps {
  ruleId: string
}

const DeleteRuleModal: React.FC<DeleteRuleModalProps> = ({ ruleId }) => {
  const { t } = useTranslation()

  const { removeDispatchRule, isLoading } = useDispatchRule()

  const handleRemove = async () => {
    try {
      await removeDispatchRule(ruleId)
      message.success(t("profile.DeleteDispatchRuleModal.deleteRuleSuccess"))
    } catch (error) {
      message.error(t("profile.DeleteDispatchRuleModal.deleteRuleError"))
      throw error
    }
  }

  return (
    <ConfirmModal
      disabled={isLoading}
      button={
        <div className="flex cursor-pointer item-center bg-[#F3F4F6] rounded-full p-2">
          <FontAwesomeIcon className="text-gray-400" icon={faTrash} />
        </div>
      }
      content={{
        type: "danger",
        title: t("profile.DeleteDispatchRuleModal.deleteRule"),
        description: t("profile.DeleteDispatchRuleModal.confirmRuleDeletion"),
        cancelText: t("common.cancel"),
        okText: t("common.delete"),
      }}
      onConfirm={handleRemove}
    />
  )
}

export default DeleteRuleModal
